import "moment/locale/en-gb";
import "moment/locale/es";
import "moment/locale/ja";
import "moment/locale/pt-br";
import "moment/locale/pl";
import "moment/locale/zh-cn";
import "moment/locale/it";
import "moment/locale/el";

import moment from "moment";
moment.locale("en");
